import { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { useMutationDeleteUser } from 'components/Settings/Components/UsersManagement/queries/useQueryUsersManagement';
import { DEFAULT_ERROR, useCustomSnackBar } from 'hooks/useCustomSnackBar';
import { useQueryClient } from 'react-query';
import classes from 'components/Settings/Components/UsersManagement/components/usersManagement.module.scss';
import { CustomizedConfirmDeleteModal, CustomizedRoundIcon } from 'components/common';
import Icon from 'components/common/Icons/icon';
import { settingsConfig } from 'components/Settings/settingsConfig';
import useUserHook from 'hooks/useUserHook';
import { AppRoutes } from 'utilitys/appRoutes/AppRoutes';

export const RowOptionsCell = ({ row }) => {
    const { email: currentUserEmail } = useUserHook();
    const { username, email } = row.original;
    const [show, setShow] = useState<boolean>(false);
    const history = useHistory();
    const mutation = useMutationDeleteUser();
    const { handleSnackBar } = useCustomSnackBar();
    const queryClient = useQueryClient();

    const handleEdit = () => {
        if (currentUserEmail === email) {
            history.push(AppRoutes.buildPath(AppRoutes.SETTINGS, settingsConfig.userProfile.link));
        } else {
            history.push(
                AppRoutes.buildPath(
                    AppRoutes.SETTINGS,
                    settingsConfig.userManagement.link,
                    settingsConfig.userManagementEditUser.link,
                    email,
                ),
            );
        }
    };

    const handleDelete = () => {
        mutation.mutate(
            { email: username },
            {
                onSuccess: () => {
                    handleSnackBar('User Successfully Deleted', 'success');
                },
                onError: (error) => {
                    DEFAULT_ERROR({ error, handleError: handleSnackBar });
                },
                onSettled: () => {
                    setShow(false);
                    return queryClient.invalidateQueries('usersList');
                },
            },
        );
    };

    return (
        <div data-testid={'actions'} className={classes.actions}>
            <CustomizedRoundIcon onClick={handleEdit}>
                <Icon data-testid={'edit-user'} name={'edit-user-profile'} />
            </CustomizedRoundIcon>

            <CustomizedRoundIcon onClick={() => setShow(true)}>
                <Icon data-testid={'delete-user'} name={'BIN'} />
            </CustomizedRoundIcon>
            <CustomizedConfirmDeleteModal
                isShowModal={show}
                hideModal={() => setShow(false)}
                text={`Are you sure you want to delete user ${username}?`}
                onConfirm={handleDelete}
            />
        </div>
    );
};
